import { render, staticRenderFns } from "./MisGrupos.vue?vue&type=template&id=18c12bbc&scoped=true"
import script from "./MisGrupos.vue?vue&type=script&lang=js"
export * from "./MisGrupos.vue?vue&type=script&lang=js"
import style0 from "./MisGrupos.vue?vue&type=style&index=0&id=18c12bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c12bbc",
  null
  
)

export default component.exports